import { IssueImageThumbnailProps } from "./IssueImageThumbnail.types";
import { cn } from "@facade/lib/utils";
import { forwardRef } from "react";

export const IssueImageThumbnail = forwardRef<
  HTMLButtonElement,
  IssueImageThumbnailProps
>(function IssueImageThumbnail({ item, selected, onPrefetch, onClick }, ref) {
  return (
    <button
      ref={ref}
      type="button"
      data-selected={selected}
      className={cn(
        "relative size-16 shrink-0 overflow-hidden rounded-sm border bg-background mt-1.5 mb-1.5",
        "transition-[transform,box-shadow,border-color] duration-150 ease-out",
        "hover:border-accent-higher",
        "data-[selected=true]:ring-2",
        "data-[selected=true]:ring-brand-secondary",
        "data-[selected=true]:ring-offset-2",
        "data-[selected=true]:ring-offset-background",
      )}
      onMouseEnter={onPrefetch}
      onFocus={onPrefetch}
      onClick={onClick}
    >
      <img
        src={item.thumbnailUrl ?? undefined}
        alt={item.attachment.caption ?? "Miniatura"}
        data-selected={selected}
        className={cn(
          "size-full object-cover rounded-sm",
          "data-[selected=true]:scale-94",
        )}
      />
    </button>
  );
});
